$(function () {
    var offset = 64;
    if($(".sub_site_header").length) {
        offset = 70;
    }
    $.getHeaderTopOffset = $.fn.getHeaderTopOffset = function () {

        var $guardedEl_header_tail = $('.header-tail');
        if ($guardedEl_header_tail.length) {
            var breadcrumbOffsetTop = $guardedEl_header_tail.offset().top;
        } else {
            console.warn('guard-jquery-calls: $(\'.header-tail\') not found, skipping.');
        }
        var headerOffsetTop = breadcrumbOffsetTop - offset - 1;

        return headerOffsetTop;
    }
});
